import React from "react";

function LogoutIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12.75V10.5H6.75V7.5H12V5.25L15.75 9L12 12.75ZM10.5 1.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5H10.5V3H3.75V15H10.5V13.5H12V15C12 15.3978 11.842 15.7794 11.5607 16.0607C11.2794 16.342 10.8978 16.5 10.5 16.5H3.75C3.35218 16.5 2.97064 16.342 2.68934 16.0607C2.40804 15.7794 2.25 15.3978 2.25 15V3C2.25 2.60218 2.40804 2.22064 2.68934 1.93934C2.97064 1.65804 3.35218 1.5 3.75 1.5H10.5Z"
        fill="#91A4B7"
      />
    </svg>
  );
}

export default LogoutIcon;
